export default "__VITE_ASSET__BeyDW4qv__"